<script setup name="TvbPlayer">
import { ref, reactive, inject, watch, computed } from 'vue'
// import { action } from '@/utils/gtm'
import TvbYouTuBePlayer from './components/YouTuBe/index.vue'
import TvbPlayIcon from './../TvbPlayIcon/index.vue'

const tvbYouTuBePlayerRef = ref(null)
const emits = defineEmits(['stateChange', 'play-click'])
const size = inject('size')
const props = defineProps({
  src: {
    type: String,
    default: ''
  },
  autoplay: {
    type: Boolean,
    default: false
  },
  mute: {
    type: Boolean,
    default: true
  },
  other: {
    type: Object,
    default: () => {
      return {}
    }
  }
})

// tracking
const isSendStart = ref(false)
const isTracking = computed(() => props.other?.isTracking)
const trackInfo = computed(() => props.other?.trackInfo || {})
watch(isSendStart, (value) => {
  if (value && isTracking.value) {
    console.log(trackInfo)
    // action({
    //   eventID: 'B013',
    //   eventLabel: 'album_popup',
    //   eventCategoy: 'sub_category',
    //   screenLabel: props.src || '',
    //   listName: 'video',
    //   ...trackInfo.value
    // })
  }
})

const player = reactive({ state: null })
const onStateChange = ({ state, ...other }) => {
  player.state = state
  emits('stateChange', { state, ...other })
  if (state === 'play') isSendStart.value = true
  if (state === 'ended') isSendStart.value = false
}
const play = () => tvbYouTuBePlayerRef?.value?.play()
const pause = () => {
  tvbYouTuBePlayerRef?.value?.pause()
  isSendStart.value = false
}
defineExpose({ play, pause })
</script>

<template>
  <div class="tvb-player" :class="[size]">
    <div class="tvb-player-play-layer" v-if="player.state !== 'play' && !isSendStart">
      <TvbPlayIcon
        :size="{ xl: 48, l: 48, m: 48, s: 40, xs: 40 }"
        class="tvb-player-play"
        @click="
          () => {
            if (player.state === 'play' || player.state === 'loading' || player.state === 'error') {
              pause()
            } else {
              play()
              emits('play-click')
            }
          }
        "
        :class="{
          hide: player.state === 'play' || player.state === 'loading' || player.state === 'error'
        }"
      />
      <n-spin v-if="player.state === 'loading'" class="tvb-player-play" stroke="#EEE" />
    </div>

    <div
      class="tvb-player-container"
      :style="{
        opacity: player.state === 'play' || isSendStart ? '1' : '0'
      }"
    >
      <TvbYouTuBePlayer
        v-bind="{ ...props, ...$attrs }"
        :mute="props.mute"
        ref="tvbYouTuBePlayerRef"
        @state-change="onStateChange"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tvb-player {
  position: relative;
  .tvb-player-play-layer {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    .tvb-player-play {
      position: absolute;
      left: calc((100% - 48px) / 2);
      top: calc((100% - 48px) / 2);
      z-index: 9;
    }
    z-index: 9;
  }

  .tvb-player-container {
    width: 100%;
    height: 100%;
    transition: opacity 500ms;
    background-color: #000;

    > * {
      width: 100%;
      height: 100%;
    }
  }

  :deep(.n-spin) {
    --n-size: 48px !important;
  }

  &.s,
  &.xs {
    :deep(.n-spin) {
      --n-size: 40px !important;
    }
    .tvb-player-play {
      left: calc((100% - 40px) / 2);
      top: calc((100% - 40px) / 2);
    }
  }
}
</style>
